// Badge — DRY: one status pill, reused for publish/payment/attendance states.
import type { ReactNode } from "react";

type BadgeTone = "green" | "gray" | "gold" | "red";

const TONE_CLASSES: Record<BadgeTone, string> = {
  green: "bg-green-100 text-green-700",
  gray:  "bg-gray-100 text-dm-slate",
  gold:  "bg-amber-100 text-amber-800",
  red:   "bg-red-100 text-red-700",
};

interface BadgeProps {
  tone: BadgeTone;
  children: ReactNode;
}

export default function Badge({ tone, children }: BadgeProps) {
  return (
    <span className={`text-xs px-2 py-1 rounded-full font-medium capitalize ${TONE_CLASSES[tone]}`}>
      {children}
    </span>
  );
}
